import { useApp } from "./context";
import { href } from "./router";

/** Compact sync state in the top bar, shown only when it needs a look. Hidden on builds without sync. */
export function SyncBadge() {
  const { services } = useApp();
  const { mode, status } = services.sync;
  if (mode === "local") return null;
  // Syncing and a short outbox are routine; only states that need the User show up.
  let label: string, tone: "away" | "warn" | "off";
  if (mode === "signed-out") [label, tone] = ["Sign in to sync", "off"];
  else if (status.phase === "offline") [label, tone] = [status.pending ? `Offline, ${status.pending} waiting` : "Offline", "away"];
  else if (status.phase === "error") [label, tone] = ["Sync problem", "warn"];
  else return null;
  return <a className={`ot-sync ot-sync--${tone}`} href={`${href({ page: "settings" })}`} title={status.message ?? label}>
    <span className="ot-sync__dot" aria-hidden="true"/>{label}
  </a>;
}
